const STREAM_SERVER_BASE_URL = 'https://stream.takein.com'
const STREAM_API_KEY = '46188272'

export default {
  STREAM_API_KEY: STREAM_API_KEY,
  STREAM_SERVER_BASE_URL: STREAM_SERVER_BASE_URL
}
